import React from 'react';

import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';

import { SafelyRenderHtml } from '@src/services';

const ProductSection = (props) => {
    const { id = '', content } = props;

    const contentText = React.useMemo(() => {
        if (!content) return null;

        const contentString = isArray(content) ? content.join('') : content;

        return SafelyRenderHtml(contentString);
    }, [content]);

    return (
        <section id={id} className="col-12 p-0">
            { contentText }
        </section>
    );
};

ProductSection.propTypes = {
    id: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default ProductSection;
